/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=cfe80f24"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cfe80f24&lang=less"

import exportComponent from "/data/jenkins/workspace/hbl-web-mobile-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__